import { IMPACT_ADMINISTRATOR_ROLE } from '../api/keycloak';
import { useRole } from './useRole';

export const useAdminRole = () => useRole(IMPACT_ADMINISTRATOR_ROLE);
